// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"deead117","20":"6621a940","184":"08151b93","191":"6812b91f","283":"d3f62559","328":"14760406","386":"42d1479b","576":"35000ed9","689":"76beae80","770":"57cc1398"}[chunkId] + ".chunk.js";
};